import { featureRoute } from '../helpers';
import { DaySaveStages } from '../../constants/AppConstants';

export default featureRoute('enableDaySave', DaySaveStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/daySave/Search').default);
        }, 'daysave');
    }
});
